import React from 'react'
import styled, {css, keyframes} from 'styled-components'
import {useEditor} from 'TemplateEditor/EditorProvider'
import {BlockElements} from 'TemplateEditor/Layout/Blocks'
import {shouldShowForPurchasedTicketTier} from 'TemplateEditor/templateTicketVisibility'

export function DefaultBlockHolder(props: {
  children: JSX.Element
  key: number | string
  block: BlockElements
  onClick: () => void
}) {
  const {editMode, mobileMode, viewerEventTicketId} = useEditor()

  if (!editMode && !props.block.visible) {
    return null
  }

  if (
    !editMode &&
    !shouldShowForPurchasedTicketTier({
      editMode: false,
      visible: Boolean(props.block.visible),
      visibleTicketIds: props.block.visible_ticket_ids,
      viewerEventTicketId,
    })
  ) {
    return null
  }

  return (
    <Holder
      $block={props.block}
      onClick={props.onClick}
      $mobileMode={mobileMode}
      $editMode={editMode}
    >
      {props.children}
    </Holder>
  )
}

const Holder = styled.div<{
  $block: BlockElements
  $mobileMode: boolean
  $editMode: boolean
}>`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.$editMode
      ? `
    cursor: pointer;
    transition: box-shadow 0.15s ease, outline-color 0.15s ease;
    outline: 1px solid transparent;
    outline-offset: 2px;
    &:hover {
      box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.45);
    }
  `
      : ''}
  ${(props) => (!props.$block.visible ? 'border: 2px #f7496d solid' : '')};
  ${(props) =>
    !props.$block.visible &&
    css`
      animation: ${errorBorderPulse} 1s infinite;
    `}

  padding: ${(props) =>
    props.$mobileMode
      ? props.$block.mobile.padding.top
      : props.$block.padding.top}px
    ${(props) =>
    props.$mobileMode
      ? props.$block.mobile.padding.right
      : props.$block.padding.right}px
    ${(props) =>
    props.$mobileMode
      ? props.$block.mobile.padding.bottom
      : props.$block.padding.bottom}px
    ${(props) =>
    props.$mobileMode
      ? props.$block.mobile.padding.left
      : props.$block.padding.left}px;
  background: ${(props) => props.$block.background};

  ${(props) =>
    props.$block.visibility === 'desktop'
      ? '@container (max-width: 991px) { display: none;}'
      : ''};
  ${(props) =>
    props.$block.visibility === 'mobile'
      ? '@container (min-width: 991px) { display: none;}'
      : ''};
`

export const errorBackgroundPulse = keyframes`
  0% { background-color: red; }
  50% { background-color: white; }
  100% { background-color: red; }
`

export const errorBorderPulse = keyframes`
  0% { border-color: red; }
  50% { border-color: white; }
  100% { border-color: red; }
`
